module.exports = __webpack_public_path__ + "static/media/Checked.87dab137.svg";